// Custom script for integration of Okendo reviews

let productReviewsSliderComponent = document.querySelector('.product-reviews-slider');
let nextUrl;
let loadMoreButton = document.querySelector('.reviews-product .reviews__load-more');
let availableLanguages = [
  'zh',
  'cs',
  'da',
  'nl',
  'en',
  'fr',
  'de',
  'id',
  'it',
  'ja',
  'ko',
  'pl',
  'pt',
  'ru',
  'es',
  'sv',
  'th',
  'vi',
];

let locale = availableLanguages.includes(Shopify.locale) ? Shopify.locale : 'en';

let basePath = `https://api.okendo.io/v1`;
let currentReviewsCount = 0;
let reviewsCount = window.okendoCustomConfig.product.reviewsCount;
async function initializeProductReviewsSlider() {
  if (productReviewsSliderComponent) {
    fetchOkendoReviews();
    fetchAttributeRatings();
  }
}

initializeProductReviewsSlider();
async function fetchOkendoReviews() {
  let reviewsData;
  let path;
  if (!nextUrl) {
    path =
      basePath +
      `/stores/${okendoCustomConfig.subscriberId}/products/${okendoCustomConfig.product.id}/reviews?limit=5&locale=${locale}`;
  } else {
    path = basePath + nextUrl;
  }
  try {
    let response = await fetch(path);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    reviewsData = await response.json();

    nextUrl = reviewsData?.nextUrl;

    if (!nextUrl) {
      if (loadMoreButton) loadMoreButton.style.display = 'none';
    } else {
      if (loadMoreButton) loadMoreButton.style.display = 'block';
    }

    handleReviews(reviewsData);
  } catch (error) {
    console.error('Error fetching Okendo reviews:', error);
    return null;
  }
}

if (loadMoreButton) loadMoreButton.addEventListener('click', fetchOkendoReviews);

function handleReviews(data) {
  let productReviewsSlider = productReviewsSliderComponent.querySelector('.slider');
  let productReviewsSidebarList = document.querySelector('.reviews-product .reviews__list');
  let reviewsData = data;

  if (reviewsData?.reviews?.length > 0) {
    let reviews = reviewsData.reviews;
    for (const [index, review] of reviews.entries()) {
      let slideElement = document.createElement('div');
      slideElement.classList.add('slider__slide', `slide-${index}`);
      let rating = getRatingStars(review.rating);
      let date = formatDateTimeToLocal(review.dateCreated);
      let verifiedBadge = okendoCustomConfig.assets.verifiedBadge + okendoCustomConfig.strings.verifiedBadge;
      let reviewerName = review.reviewer.displayName;
      let reviewBody = review.body;
      let media = review.media;
      let reply = review.reply?.body;

      slideElement.innerHTML = `
          <div class="review-header">
            <span class="review-header__rating">${rating}</span>
            <span class="review-header__date small-text small-hide">${date}</span>
            <span class="review-header__verified-badge">${verifiedBadge}</span>
          </div>
          <div class="review-user">
            ${okendoCustomConfig.assets.customer}
            ${reviewerName}
          </div>
          <span class="review-header__date small-text medium-hide large-up-hide">${date}</span>
          <div class="review-body">
              <span class="review-body__content">
                ${window.reviewStrings.no_text_rating}
              </span>
          </div>
        `;
      productReviewsSlider.appendChild(slideElement);

      if (!productReviewsSidebarList) return;

      let modalReviewItem = document.createElement('div');
      modalReviewItem.classList.add('reviews__item');
      modalReviewItem.innerHTML = `
          <div class="review-header">
            <span class="review-header__rating">${rating}</span>
            <span class="review-header__date small-hide">${date}</span>
            <span class="review-header__verified-badge">${verifiedBadge}</span>
          </div>
          <div class="review-user">${okendoCustomConfig.assets.customer} ${reviewerName}</div>
          <span class="review-header__date medium-hide large-up-hide">${date}</span>
          <div class="review-body">${window.reviewStrings.no_text_rating}</div>
        `;

      if (media && media.length > 0) {
        let modalReviewMedia = document.createElement('div');
        modalReviewMedia.classList.add('review-media__list');
        for (const [index, mediaItem] of media.entries()) {
          let mediaElement = document.createElement('img');
          mediaElement.classList.add('review-media__item');
          mediaElement.src = mediaItem.largeUrl;
          mediaElement.alt = `Review Media ${index + 1}`;
          modalReviewMedia.appendChild(mediaElement);
        }
        modalReviewItem.appendChild(modalReviewMedia);
      }

      productReviewsSidebarList.appendChild(modalReviewItem);

      if (reply) {
        let modalReviewReply = document.createElement('div');
        modalReviewReply.classList.add('review-reply');
        modalReviewReply.innerHTML = `
            <div class="review-reply__header">
              <img src="${okendoCustomConfig.assets.storeLogo}" alt="Dedoles Logo" />
              <span>${okendoCustomConfig.strings.storeReplyHeader}</span>
            </div>
            <div class="review-reply__body">${reply}</div>
          `;
        modalReviewItem.appendChild(modalReviewReply);
      }

      let divider = document.createElement('div');
      divider.classList.add('review-divider');
      productReviewsSidebarList.appendChild(divider);
    }

    if (okendoCustomConfig.pageType == 'product') handleReviewsCountBar(reviewsData);
  }
}

function handleReviewsCountBar(data) {
  let reviewsCountText = document.querySelector('.reviews-product .reviews__count-text');
  let reviewsCountBarFill = document.querySelector('.reviews-product .reviews__count-bar-fill');
  currentReviewsCount += data.reviews.length;
  let fill = parseFloat((currentReviewsCount / reviewsCount) * 100).toFixed(2);
  reviewsCountBarFill.style.width = `${fill}%`;
  reviewsCountText.innerHTML = okendoCustomConfig.strings.youHaveSeenReviews
    .replace('{{ count }}', currentReviewsCount)
    .replace('{{ total }}', reviewsCount);
}

function getRatingStars(rating) {
  let ratingStars = '';
  for (let i = 0; i < rating; i++) {
    ratingStars += okendoCustomConfig.assets.star;
  }
  return ratingStars;
}

function formatDateTimeToLocal(isoString) {
  const date = new Date(isoString);

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
}

async function fetchAttributeRatings() {
  try {
    const path = `${basePath}/stores/${okendoCustomConfig.subscriberId}/products/${okendoCustomConfig.product.id}/review_aggregate`;

    const response = await fetch(path);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const aggregateData = await response.json();
    if (aggregateData && aggregateData.reviewAggregate.attributeRatings) {
      displayAttributeRatings(aggregateData.reviewAggregate.attributeRatings);
    }
  } catch (error) {
    console.error('Error fetching attribute ratings:', error);
  }
}

function displayAttributeRatings(attributeRatings) {
  const attributesContainers = document.querySelectorAll('.reviews-product .rating-attributes');
  if (!attributesContainers || attributesContainers.length === 0) {
    console.warn('No rating attribute containers found on the page');
    return;
  }

  attributesContainers.forEach((attributesContainer) => {
    attributesContainer.innerHTML = '';

    const fragment = document.createDocumentFragment();

    attributeRatings.forEach((attr) => {
      const value = Math.min(Math.max(parseFloat(attr.value) || 0, 0), 5);
      const percentage = (value / 5) * 100;
      const attributeName = attr.title.toLowerCase();
      const labelKey = `attr_${attributeName}_label`;
      const minLabelKey = `attr_${attributeName}_min_label`;
      const maxLabelKey = `attr_${attributeName}_max_label`;

      const attributeElement = document.createElement('div');
      attributeElement.classList.add('rating-attribute');
      attributeElement.innerHTML = `
        <div class="rating-attribute__label subtitle-small">${window.reviewStrings[labelKey] || attr.title}</div>
        <div class="rating-attribute__scale">
          <div class="rating-attribute__bar"></div>
          <div class="rating-attribute__marker" style="left: ${percentage}%;"></div>
        </div>
        <div class="rating-attribute__range">
          <span class="rating-attribute__min text-x-small">${window.reviewStrings[minLabelKey] || attr.minLabel}</span>
          <span class="rating-attribute__max text-x-small">${window.reviewStrings[maxLabelKey] || attr.maxLabel}</span>
        </div>
      `;

      fragment.appendChild(attributeElement);
    });

    attributesContainer.appendChild(fragment);
  });
}
